export const announcements = [
  {
    "id": "welcome-curated-path",
    "title": {
      "en": "Begin your path",
      "es": "Comienza tu camino",
      "nl": "Begin je pad",
      "pap": "Kuminsá bo kaminda"
    },
    "message": {
      "en": "Begin with the curated path, then continue into the deeper programs, media, and study materials.",
      "es": "Empieza con el camino guiado y luego continúa hacia los programas, los medios y los materiales de estudio más profundos.",
      "nl": "Begin met het samengestelde pad en ga daarna verder met de verdiepende programma's, media en studiematerialen.",
      "pap": "Kuminsá ku e kaminda guiá, despues sigui den e programanan, media i materialnan di estudio mas profundo."
    },
    "status": "active",
    "startDate": "2026-06-26T00:00:00Z",
    "endDate": null,
    "ctaLabel": null,
    "ctaUrl": null,
    "priority": 10
  }
];
